import { Icon } from '@treezor/design-system';
import { useTranslation } from 'react-i18next';

import { ITransactionByDigitizedCard } from '@/features/cards/store/models/card.model';
import { mappingIso3Countries } from '@/utils/constants';
import {
  getCardTransactionConfigKey,
  TCardTransactionColumnSetting,
} from '@/features/cards/store/models/card-transactions.model';

interface IPaymentMerchantCellProps {
  transaction: ITransactionByDigitizedCard;
  config?: TCardTransactionColumnSetting;
}

export function PaymentMerchantCell({ transaction, config }: IPaymentMerchantCellProps) {
  const { t } = useTranslation();

  const merchantCountryCode = mappingIso3Countries?.[transaction?.merchantCountry];

  const merchantData = [
    transaction?.merchantCity,
    ...(merchantCountryCode ? [t(`shared.countries.${merchantCountryCode}`)] : []),
  ].filter(Boolean);
  const hasSubtitle = merchantData.length > 0;

  return (
    <div className="flex flex-col gap-1">
      {getCardTransactionConfigKey(config, 'merchantName') && (
        <div className="flex items-center gap-3">
          <span className="typo-body-semibold-small text-secondary text-nowrap">
            {transaction?.optimizedMerchantName || transaction?.merchantName || '-'}
          </span>
          {transaction?.merchantLogo && (
            <img className="w-5 h-5 bg-primary border border-primary" src={transaction.merchantLogo} />
          )}
        </div>
      )}
      {hasSubtitle && getCardTransactionConfigKey(config, 'merchantAddress') && (
        <div className="flex items-center gap-2">
          <Icon isFill={false} name="location_on" size="s" className="text-tertiary"></Icon>
          <span className="typo-body-regular-small text-tertiary text-nowrap">
            {merchantData.length === 1 ? merchantData[0] : merchantData.join(', ')}
          </span>
        </div>
      )}
    </div>
  );
}
